import { CartLogo } from "../svg/cart";
import useButtonAddToCart from "../../../hooks/useButtonAddToCart";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";
import IntegrationService from "../../../../../service/IntegrationService";
import GetUserInfoService from "../../../../../service/GetUserInfoService";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";
import CartIcon from "../../../../images/cart.png";
import CartFullIcon from "../../../../images/cart-full.png";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../../../../contexts/CartContext/CartContext";
import { Tag } from "primereact/tag";
import "../ProductCard.css";

const integrationService = new IntegrationService();
const getUserInfoService = new GetUserInfoService();

export const MiniAddToCart = ({
  productInfo,
  currentVariation,
  currentAttribute1Value,
  currentAttribute2Value,
  productQty,
  productSectionButton,
  productCardMobile,
  containerWidth,
}) => {
  /* const { addItemToCart } = useContext(CartContext); */
  const { showErrorToast } = useToastContext();
  const { addToCart, loadingOrder, cartFull } = useButtonAddToCart({
    currentVariation: currentVariation,
    currentAttribute1Value,
    currentAttribute2Value,
    productQty,
    productInfo,
    onErrorAddToCart: (code) => showErrorToast({ code }),
    onErrorDownloadableAndNonDownloadable: () =>
      showErrorToast({
        detail: "downloadableAndNonDownloadable",
      }),
    onErrorData: (code) => showErrorToast({ code }),
    onErrorItemAlreadyInCart: () => showErrorToast({ detail: "itemAlreadyInCart" }),
    onErrorOneSeller: () => showErrorToast({ detail: "onlyOneSeller" }),
  });
  const isSmallCard = containerWidth <= 250;

  const product = productInfo?.data?.product;
  const productVariations = productInfo?.data?.productVariations || [];
  const isOutOfStock =
    !!product &&
    !product.downloadable &&
    !product.service &&
    (productVariations.length > 0
      ? productVariations.every((variation) => !(variation.amountInStock > 0))
      : !(product.amountInStock > 0));

  const isDisabled = loadingOrder
    ? "opacity-80 pointer-events-none cursor-pointer flex align-items-center justify-content-center sm:p-2 p-1 border-green-400 sm:border-3 border-2 border-solid border-round-md"
    : "cursor-pointer flex align-items-center justify-content-center sm:p-2 p-1 border-green-400 border-2 border-solid border-round-md hover:bg-gray-100";
  const buttonClass = `${isDisabled}`;

  async function getUserInfo() {
    let info = await getUserInfoService.getUserInfo(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username")
    );
    senAddCart(info.result.user);
  }
  async function senAddCart(user) {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "AddCart",
    });
    let ip = await integrationService.getUserIp();
    let date = new Date();
    let payload = {
      eventData: {
        currency: "",
        value: 0,
      },
      eventName: "AddCart",
      eventTime: Math.floor(date.getTime() / 1000),
      userData: {
        email: user ? user.email : "",
        ipAddress: ip.data.ip,
        phone: "",
        userAgent: window.navigator.userAgent,
      },
    };
    let res = await integrationService.sendEvent(payload);
    return res;
  }

  const addCart = async (sectionButton) => {
    console.log("section", sectionButton)
    if (productInfo?.data?.user?.username === localStorage.getItem("__extraconomy_username")) {
      showErrorToast({ detail: "errorThisProductIsYours" });
      return;
    }

    localStorage.getItem("__extraconomy_token") ? getUserInfo() : senAddCart(null);
    addToCart(sectionButton);
  };

  return (
    <>
      {productCardMobile ? (
        <>
          <Tag
            className={`font-normal px-2 py-1 border-round ${
              isOutOfStock ? "opacity-60" : "cursor-pointer"
            }`}
            style={{ backgroundColor: isOutOfStock ? "#DFE1E6" : "#FFC839", color: "#091E42" }}
            rounded
            onClick={isOutOfStock ? undefined : () => addCart(true)}
            disabled={!loadingOrder}
          >
            {isOutOfStock ? (
              localeText("outOfStock")
            ) : (
              <div className="flex align-items-center gap-1">
                {cartFull ? (
                  <img style={{ width: "13px" }} src={CartFullIcon} alt="CartIcon"></img>
                ) : (
                  <img style={{ width: "13px" }} src={CartIcon} alt="CartIcon"></img>
                )}{" "}
                {loadingOrder
                  ? localeText("adding")
                  : cartFull
                  ? localeText("added")
                  : localeText("add")}
              </div>
            )}
          </Tag>
        </>
      ) : (
        <>
          {productSectionButton ? (
            <Button
              outlined
              className="px-4 border-round-md w-full sm:w-auto flex justify-content-center gap-2"
              style={{ color: "#46A748" }}
              onClick={() => addCart(productSectionButton)}
              disabled={loadingOrder || isOutOfStock}
            >
              <i className="pi pi-shopping-cart"></i>{" "}
              <span className="sm:hidden py-1">
                {loadingOrder ? localeText("adding") : localeText("addToCart")}
              </span>
            </Button>
          ) : (
            <Button
              className={`w-full gap-2 p-no-outline font-semibold  border-none border-round-md add-to-cart-button justify-content-center ${
                loadingOrder ? "italic" : ""
              } ${isSmallCard ? "small-card-button" : "px-4 py-3 text-sm"}`}
              onClick={() => addCart(true)}
              disabled={loadingOrder || isOutOfStock}
            >
              {isOutOfStock ? (
                localeText("outOfStock")
              ) : (
                <>
                  {cartFull ? (
                    <img src={CartFullIcon} alt="CartIcon"></img>
                  ) : (
                    <img src={CartIcon} alt="CartIcon"></img>
                  )}{" "}
                  {loadingOrder
                    ? localeText("adding")
                    : cartFull
                    ? localeText("added")
                    : localeText("addToCart")}
                </>
              )}
            </Button>
          )}
        </>
      )}
    </>
  );
};
